export default __webpack_public_path__ + "assets/enterprise-three-two.7d013b3751f38a92fa0ca3b43545ae79.png";